import z from 'zod';
import { ruleEditorSchema, ruleTypeSchema } from 'schemas/IterationRule.schema';

export const libraryRuleSchema = z.object({
  Type: z.array(ruleTypeSchema),
  Name: z.string(),
  Category: z.string().optional(),
  Description: z.string().optional(),
  LibraryDescription: z.string().optional(),
  Operator: z.string(),
  Comparator: z.string().optional(),
  AttributeLevel: z.string(),
  AttributeName: z.string(),
  AttributeTarget: z.string().optional(),
  LibraryRuleMetadata: ruleEditorSchema.optional(),
});
export type LibraryRuleMetadata = z.infer<typeof libraryRuleSchema>;
